import React, {useMemo} from "react";
import useProductInfo from "@widgets/pos/order/menu/product/context/ProductInfoProvider";
import {ProductSelectionGroup} from "@/data/entities/cart";
import ProductOptionList from "@widgets/pos/order/menu/product/options/option/ProductOptionList";
import {Field, Label} from "headlessui-v2";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";

const getDisplayName = (groupName: string) => {
    if (groupName.startsWith("Ingrediënten weglaten -")) {
        return "Ingrediënten weglaten"
    }

    return groupName;
};

type Props = {
    group: ProductSelectionGroup,
};

const ProductOptionGroup = ({group}: Props) => {
    const {canAddToBasket} = useProductInfo();
    const displayName: string = useMemo(() => getDisplayName(group.groupName), [group.groupName]);

    return (
        <Field
            as={"li"}
            disabled={!canAddToBasket}
            className={"w-full flex flex-col gap-2"}
        >
            <div className={"w-full flex flex-row items-end justify-between gap-3 flex-wrap"}>
                <Label className={"font-medium"}>
                    {displayName}
                </Label>

                <Badge
                    role={"note"}
                    color={group.isRequired ? "primary" : "secondary"}
                >
                    {
                        group.isRequired
                            ? <FormattedMessage id={"required"}/>
                            : (
                                group.maxOptions > 0
                                    ? <FormattedMessage
                                        id={"optional-with-max"}
                                        values={{n: group.maxOptions}}
                                    />
                                    : <FormattedMessage id={"optional"}/>
                            )
                    }
                </Badge>
            </div>

            <ProductOptionList
                displayName={displayName}
                group={group}
            />
        </Field>
    );
};

export default ProductOptionGroup;